import React from 'react';
import PropTypes from 'prop-types';
import styles from './Comment.scss';
import { translate } from 'react-i18next';
import moment from 'moment';

import { FormField, InputArea, Text } from 'wix-style-react';

class Comment extends React.Component {
  getCommentSignatureText = () => {
    const { t, locale } = this.props;
    const { comment } = this.props;

    if (comment.timestamp) {
      const m = moment(comment.timestamp).locale(locale);
      const date = m.format('ll');
      const time = m.format('LT');
      return t('phoneordering_customerinfo_contactdetails_lastedited', { date, time });
    } else {
      return t('phoneordering_customerinfo_contactdetails_editednow');
    }
  };

  onCommentChange = e => {
    const text = e.target.value;
    this.props.onCommentTextChange(text);
  };

  render() {
    const { t, comment } = this.props;

    return (
      <React.Fragment>
        <FormField
          label={
            <Text size="medium" secondary>
              {t('phoneordering_customerinfo_contactdetails_comments_label')}
            </Text>
          }
        >
          <InputArea
            minHeight='66px'
            value={comment.text}
            onChange={this.onCommentChange}
            dataHook="customer-info-comment"
            placeholder={t('phoneordering_customerinfo_contactdetails_comments_placeholder')}
          />
        </FormField>
        {comment.text && (
          <div className={styles.commentSignature}>
            <Text data-hook="customer-info-comment-signature" size="tiny" secondary>
              {this.getCommentSignatureText()}
            </Text>
          </div>
        )}
      </React.Fragment>
    );
  }
}

Comment.displayName = 'Comment';
Comment.propTypes = {
  comment: PropTypes.object,
  agentName: PropTypes.string,
  locale: PropTypes.string,
  onCommentTextChange: PropTypes.func,
};

export default translate()(Comment);
